import { render, staticRenderFns } from "./scanCode.vue?vue&type=template&id=94d20768&scoped=true"
import script from "./scanCode.vue?vue&type=script&lang=js"
export * from "./scanCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94d20768",
  null
  
)

export default component.exports